import React from "react";
// javascipt plugin for creating charts

import { Line } from "react-chartjs-2";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
// core components

import componentStyles from "assets/theme/components/cards/dashboard/card-sales-value.js";

const useStyles = makeStyles(componentStyles);

function CardSalesValue(props) {
  const classes = useStyles();
  const theme = useTheme();
  const themeColors = require("assets/theme/colors.js").default;

  if(props.stats == null || props.stats == undefined){
    props.stats = [];
  } 

  let chartConfig = {
    options: {
      scales: {
        yAxes: [
          {
            gridLines: {
              color: themeColors.gray[700],
              zeroLineColor: themeColors.gray[700],
            },
            ticks: {
              callback: function (value) {
                if (!(value % 10)) {
                  return value;
                }
              },
            },
          },
        ],
      },
      tooltips: {
        callbacks: {
          label: function (item, data) {
            var label = data.datasets[item.datasetIndex].label || "";
            var yLabel = item.yLabel;
            var content = "";
  
            if (data.datasets.length > 1) {
              content += label;
            }
  
            content += "" + yLabel + "";
            return content;
          },
        },
      },
    },
    data: () => {
      return {
        labels: props.stats.map(function(stat, idx) {
          return stat.month.replace(' ','');
      }),
        datasets: [
          {
            label: "Performance",
            data: props.stats.map(function(stat, idx) {
              return stat.count;
          }),
          },
        ],
      };
    }
  };

    return (
      <>
        <Card
          classes={{
            root: classes.cardRoot + " ",
          }}
        >
          <CardHeader
            subheader={
              <Grid
                container
                component={Box}
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item xs="auto">
                  <Box
                    component={Typography}
                    variant="h6"
                    letterSpacing=".0625rem"
                    marginBottom=".25rem!important"
                    className={classes.textUppercase}
                  >
                    <Box component="span" color={theme.palette.gray[800]}>
                      Overview
                  </Box>
                  </Box>
                  <Box
                    component={Typography}
                    variant="h2"
                    marginBottom="0!important"
                  >
                    <Box component="span" color={theme.palette.white.dark}>
                      Sales count
                  </Box>
                  </Box>
                </Grid>
              </Grid>
            }
            classes={{ root: classes.cardHeaderRoot }}
          ></CardHeader>
          <CardContent>
            <Box position="relative" height="380px">
              <Line
                data={chartConfig["data"]}
                options={chartConfig.options}
              />
            </Box>
          </CardContent>
        </Card>
      </>
    );
  }

  export default CardSalesValue;
